<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectCustomerType,
} from '../../../../model/additional-info/success/info-customer-type/select-customer-type.hook'

defineOptions({
  name: 'SelectCustomerType',
})

const {
  placeholder,
  model,
  options,
} = useSelectCustomerType()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
